import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../../components/common/table";
import { downloadInvoicePdf } from "../../services/invoiceService";
import { toast } from "react-toastify";

function formatMoney(value) {
  const amount = Number(value || 0);
  return Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN" }).format(amount);
}

class InvoicesTable extends Component {
  handleDownload = async (invoice) => {
    try {
      await downloadInvoicePdf(invoice.id, `invoice-${invoice.invoicenum}.pdf`);
    } catch (ex) {
      toast.error("Failed to download invoice PDF.");
    }
  };

  columns = [
    {
      path: "invoicenum",
      label: "Invoice #",
      content: (invoice) => (
        <Link to={`/invoices/${invoice.id}`}>{invoice.invoicenum}</Link>
      ),
    },
    { path: "status", label: "Status" },
    {
      path: "obligationLabel",
      label: "Type",
      content: (invoice) => invoice.obligationLabel || "Invoice",
    },
    {
      path: "issuedate",
      label: "Issued",
      content: (invoice) => invoice.issuedate || "—",
    },
    {
      path: "duedate",
      label: "Due",
      content: (invoice) => invoice.duedate || "—",
    },
    {
      path: "total",
      label: "Total",
      content: (invoice) => formatMoney(invoice.total),
    },
    {
      path: "balance",
      label: "Balance",
      content: (invoice) => formatMoney(invoice.balance),
    },
    {
      key: "actions",
      label: "",
      content: (invoice) => (
        <span>
          {this.props.showPay && Number(invoice.balance) > 0 && (
            <button
              type="button"
              className="btn btn-primary btn-sm mr-2"
              onClick={() => this.props.onPay(invoice)}
            >
              Pay now
            </button>
          )}
          <button type="button" className="btn btn-link btn-sm p-0" onClick={() => this.handleDownload(invoice)}>
            <i className="fa fa-file-pdf-o" /> PDF
          </button>
        </span>
      ),
    },
  ];

  render() {
    const { invoices, onSort, sortColumn } = this.props;
    return (
      <Table
        columns={this.columns}
        data={invoices}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default InvoicesTable;
